// 禁飞区管理
export default {
    noFlyZoneName: 'No-fly zone name',
    noFlyZoneDescription: 'No-fly zone description',
    addNoFlyZone: 'Add no-fly zone',
    status: 'Status',
    efficient: 'Efficient',
    invalid: 'Invalid',
    noFlyZoneActivationTime: 'No-fly zone activation time',
    noFlyZoneValidityPeriod: 'No-fly zone validity period',
    position: 'Position',
    tip_removeNoFlyZone: 'Once the no-fly zone is deleted, it cannot be restored, please operate with caution!',
    validityPeriod: 'Validity Period',
    number: 'Number',
    tip_noFlyZoneName: 'No-fly zone name cannot be empty',
    tip_noFlyZoneIllustrate: 'No-fly zone description cannot be empty',
    tip_noFlyZonePoint: 'Add no-fly zone points can not be less than three',
    tip_selectDate: 'Please select an expiration date',
}